import React, { useEffect, useState } from 'react'
import { FaMoneyBill, FaUser } from 'react-icons/fa'
import { MdHealthAndSafety } from 'react-icons/md'
import { RiHospitalFill } from 'react-icons/ri'
import adminServices from '../../services/AdminServices'

function Statistics() {
    const [statistics, setStatics] = useState()
    useEffect(() => {
        adminServices.getStats().then(
            res => {
                setStatics(res.data)
            },
            err => {
                console.log(err);
                
            }
        )
    }, [])
    useEffect(() => {}, [statistics])
    return (
        <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">All Patients</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.total_patients}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3 ">
                            <span className="material-symbols-outlined"><FaUser className='h-6 w-6'/></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Nurses</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.total_nurses}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><MdHealthAndSafety className='h-6 w-6'/></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Requests</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.total_requests}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><RiHospitalFill className='h-6 w-6'/></span>
                        </div>
                    </div>
                </div>
                <div className="relative overflow-hidden rounded-xl border border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-6 shadow-sm transition-all hover:shadow-md">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Revenue</p>
                            <p className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">{statistics?.total_revenue}</p>
                        </div>
                        <div className="rounded-lg bg-primary/10 text-primary p-2 md:p-3">
                            <span className="material-symbols-outlined"><FaMoneyBill className='h-6 w-6'/></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Statistics